class CartRecommendations extends HTMLElement {

	constructor(){
		super();
		this.generateRecommendations();
	}

	generateRecommendations(){
		const cartItems = document.getElementById('AjaxCartForm').querySelectorAll('[data-js-cart-item]');
		if ( cartItems.length > 0 ) {
			fetch(`${KROWN.settings.routes.product_recommendations_url}?section_id=${this.dataset.section}&product_id=${cartItems[0].dataset.productId}&limit=${this.dataset.limit}`)
				.then(response => response.text())
				.then(text => {
					const innerHTML = new DOMParser()
            .parseFromString(text, 'text/html')
            .querySelector('[data-js-cart-recommendations-performed]');
          if ( innerHTML && innerHTML.querySelectorAll('[data-js-product-item]').length > 0 ) {

          	if ( this.dataset.displayLimit ) {
          		const displayLimit = parseInt(this.dataset.displayLimit);
          		innerHTML.querySelectorAll('[data-js-product-item]').forEach((item, index) => {
          			if ( index >= displayLimit ) {
          				item.remove();
          			}
          		});
          	}

          	if ( this.dataset.heading && innerHTML.querySelector('[data-js-cart-recommendations-heading]') ) {
          		innerHTML.querySelector('[data-js-cart-recommendations-heading]').textContent = this.dataset.heading;
          	}

          	this.innerHTML = innerHTML.innerHTML;
          }
				})
				.catch(() => {
					this.innerHTML = '';
				})
		}
	}
}
customElements.define('cart-recommendations', CartRecommendations);